import { __awaiter, __generator } from "tslib";
import { parse as parseHtml, } from 'node-html-better-parser';
import { colorString } from './colors';
import { degreesToRadians } from './rotations';
import { LineCapStyle, LineJoinStyle } from './operators';
var StrokeLineCapMap = {
    'butt': LineCapStyle.Butt,
    'round': LineCapStyle.Round,
    'square': LineCapStyle.Projecting,
};
var StrokeLineJoinMap = {
    'bevel': LineJoinStyle.Bevel,
    'miter': LineJoinStyle.Miter,
    'round': LineJoinStyle.Round,
};
var runnersToPage = function (page, options) { return ({
    text: function (element) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                page.drawText(element.childNodes[0].text, {
                    x: options.x + element.svgAttributes.x,
                    y: options.y - element.svgAttributes.y,
                    font: options.fonts && element.svgAttributes.fontFamily
                        ? options.fonts[element.svgAttributes.fontFamily]
                        : undefined,
                    size: element.svgAttributes.fontSize,
                    color: element.svgAttributes.fill,
                    opacity: element.svgAttributes.fillOpacity,
                });
                return [2 /*return*/];
            });
        });
    },
    line: function (element) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                page.drawLine({
                    start: {
                        x: options.x + element.svgAttributes.x1,
                        y: options.y - element.svgAttributes.y1,
                    },
                    end: {
                        x: options.x + element.svgAttributes.x2,
                        y: options.y - element.svgAttributes.y2,
                    },
                    thickness: element.svgAttributes.strokeWidth,
                    color: element.svgAttributes.stroke,
                    opacity: element.svgAttributes.strokeOpacity,
                    lineCap: element.svgAttributes.strokeLineCap,
                });
                return [2 /*return*/];
            });
        });
    },
    path: function (element) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                page.drawSvgPath(element.svgAttributes.d, {
                    x: options.x + element.svgAttributes.x,
                    y: options.y - element.svgAttributes.y,
                    borderColor: element.svgAttributes.stroke,
                    borderWidth: element.svgAttributes.strokeWidth,
                    borderOpacity: element.svgAttributes.strokeOpacity,
                    borderLineCap: element.svgAttributes.strokeLineCap,
                    color: element.svgAttributes.fill,
                    opacity: element.svgAttributes.fillOpacity,
                    scale: element.svgAttributes.scale,
                    rotate: element.svgAttributes.rotate,
                });
                return [2 /*return*/];
            });
        });
    },
    image: function (element) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _b = (_a = page).drawImage;
                        return [4 /*yield*/, page.doc.embedPng(element.svgAttributes.src)];
                    case 1:
                        _b.apply(_a, [_c.sent(), {
                                x: options.x + element.svgAttributes.x,
                                y: options.y - element.svgAttributes.y,
                                width: element.svgAttributes.width,
                                height: element.svgAttributes.height,
                                opacity: element.svgAttributes.fillOpacity,
                                xSkew: element.svgAttributes.skewX,
                                ySkew: element.svgAttributes.skewY,
                                rotate: element.svgAttributes.rotate,
                            }]);
                        return [2 /*return*/];
                }
            });
        });
    },
    rect: function (element) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!element.svgAttributes.fill && !element.svgAttributes.stroke)
                    return [2 /*return*/];
                page.drawRectangle({
                    x: options.x + element.svgAttributes.x,
                    y: options.y - element.svgAttributes.y,
                    width: element.svgAttributes.width,
                    height: element.svgAttributes.height,
                    borderColor: element.svgAttributes.stroke,
                    borderWidth: element.svgAttributes.strokeWidth,
                    borderOpacity: element.svgAttributes.strokeOpacity,
                    borderLineCap: element.svgAttributes.strokeLineCap,
                    color: element.svgAttributes.fill,
                    opacity: element.svgAttributes.fillOpacity,
                    xSkew: element.svgAttributes.skewX,
                    ySkew: element.svgAttributes.skewY,
                    rotate: element.svgAttributes.rotate,
                });
                return [2 /*return*/];
            });
        });
    },
    ellipse: function (element) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                page.drawEllipse({
                    x: options.x + element.svgAttributes.x + element.svgAttributes.cx,
                    y: options.y - element.svgAttributes.y - element.svgAttributes.cy,
                    xScale: element.svgAttributes.rx,
                    yScale: element.svgAttributes.ry,
                    borderColor: element.svgAttributes.stroke,
                    borderWidth: element.svgAttributes.strokeWidth,
                    borderOpacity: element.svgAttributes.strokeOpacity,
                    borderLineCap: element.svgAttributes.strokeLineCap,
                    color: element.svgAttributes.fill,
                    opacity: element.svgAttributes.fillOpacity,
                    rotate: element.svgAttributes.rotate,
                });
                return [2 /*return*/];
            });
        });
    },
    circle: function (element) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                page.drawCircle({
                    x: options.x + element.svgAttributes.x + element.svgAttributes.cx,
                    y: options.y - element.svgAttributes.y - element.svgAttributes.cy,
                    size: element.svgAttributes.r,
                    borderColor: element.svgAttributes.stroke,
                    borderWidth: element.svgAttributes.strokeWidth,
                    borderOpacity: element.svgAttributes.strokeOpacity,
                    borderLineCap: element.svgAttributes.strokeLineCap,
                    color: element.svgAttributes.fill,
                    opacity: element.svgAttributes.fillOpacity,
                });
                return [2 /*return*/];
            });
        });
    },
}); };
var transform = function (_a, name, args) {
    var x = _a.x, y = _a.y;
    var angle;
    var tempResult;
    switch (name) {
        case 'scale':
            x = x * args[0];
            y = y * (args.length > 1 ? args[1] : args[0]);
            break;
        case 'translate':
            x = x + args[0];
            y = y + args[1] || 0;
            break;
        case 'rotate':
            if (args.length === 1) {
                angle = degreesToRadians(args[0]);
                x = Math.cos(angle) * x - Math.sin(angle) * y;
                y = Math.sin(angle) * x + Math.cos(angle) * y;
            }
            else {
                tempResult = transform({ x: x, y: y }, 'translate', [args[1], args[2]]);
                tempResult = transform(tempResult, 'rotate', [args[0]]);
                tempResult = transform(tempResult, 'translate', [
                    -args[1],
                    -(args[2] || 0),
                ]);
                x = tempResult.x;
                y = tempResult.y;
            }
            break;
        case 'skewX':
            angle = degreesToRadians(args[0]);
            x = x + Math.tan(angle) * y;
            break;
        case 'skewY':
            angle = degreesToRadians(args[0]);
            y = Math.tan(angle) * x + y;
            break;
    }
    return { x: x, y: y };
};
var styleOrAttribute = function (attributes, style, attribute, def) {
    var value = style[attribute] || attributes[attribute];
    if (!value && typeof def !== 'undefined')
        return def;
    return value;
};
var parseStyles = function (style) {
    var cssRegex = /([^:\s]+)*\s*:\s*([^;]+)/g;
    var css = {};
    var match = cssRegex.exec(style);
    while (match != null) {
        css[match[1]] = match[2];
        match = cssRegex.exec(style);
    }
    return css;
};
var parseColor = function (color) {
    if (!color || color.length === 0)
        return undefined;
    if (['none', 'transparent'].includes(color))
        return undefined;
    return colorString(color);
};
var parseAttributes = function (element, parentElement, constraints) {
    var attributes = element.attributes;
    var style = parseStyles(attributes.style);
    var widthRaw = styleOrAttribute(attributes, style, 'width', '');
    var heightRaw = styleOrAttribute(attributes, style, 'height', '');
    var fillRaw = parseColor(styleOrAttribute(attributes, style, 'fill'));
    var fillOpacityRaw = styleOrAttribute(attributes, style, 'fill-opacity');
    var strokeRaw = parseColor(styleOrAttribute(attributes, style, 'stroke'));
    var strokeOpacityRaw = styleOrAttribute(attributes, style, 'stroke-opacity');
    var strokeLineCapRaw = styleOrAttribute(attributes, style, 'stroke-linecap');
    var strokeLineJoinRaw = styleOrAttribute(attributes, style, 'stroke-linejoin');
    var strokeWidthRaw = styleOrAttribute(attributes, style, 'stroke-width');
    var fontFamilyRaw = styleOrAttribute(attributes, style, 'font-family');
    var fontSizeRaw = styleOrAttribute(attributes, style, 'font-size');
    var box = (parentElement && parentElement.svgAttributes) || {};
    var width;
    if (widthRaw && parseFloat(widthRaw)) {
        width = parseFloat(widthRaw);
        if (widthRaw.includes('%')) {
            width = (box.width || 0) * (width / 100.0);
        }
    }
    else if (box.width) {
        width = box.width;
    }
    var height;
    if (heightRaw && parseFloat(heightRaw)) {
        height = parseFloat(heightRaw);
        if (heightRaw.includes('%')) {
            height = (box.height || 0) * (height / 100.0);
        }
    }
    else if (box.height) {
        height = box.height;
    }
    var x = typeof attributes.x !== 'undefined' ? parseFloat(attributes.x) : 0;
    var y = typeof attributes.y !== 'undefined' ? parseFloat(attributes.y) : 0;
    var x1 = typeof attributes.x !== 'undefined' ? parseFloat(attributes.x1) : 0;
    var y1 = typeof attributes.y !== 'undefined' ? parseFloat(attributes.y1) : 0;
    var x2 = typeof attributes.x !== 'undefined' ? parseFloat(attributes.x2) : 0;
    var y2 = typeof attributes.y !== 'undefined' ? parseFloat(attributes.y2) : 0;
    var cx = typeof attributes.cx !== 'undefined' ? parseFloat(attributes.cx) : 0;
    var cy = typeof attributes.cy !== 'undefined' ? parseFloat(attributes.cy) : 0;
    var r = typeof attributes.r !== 'undefined' ? parseFloat(attributes.r) : 0;
    var rx = typeof attributes.rx !== 'undefined' ? parseFloat(attributes.rx) : 0;
    var ry = typeof attributes.ry !== 'undefined' ? parseFloat(attributes.ry) : 0;
    var fill = fillRaw || box.fill;
    var fillOpacity = typeof fillOpacityRaw !== 'undefined'
        ? parseFloat(fillOpacityRaw)
        : box.fillOpacity;
    var stroke = strokeRaw || box.stroke;
    var strokeOpacity = typeof strokeOpacityRaw !== 'undefined'
        ? parseFloat(strokeOpacityRaw)
        : box.strokeOpacity;
    var strokeLineCap = StrokeLineCapMap[strokeLineCapRaw] || box.strokeLineCap;
    var strokeLineJoin = StrokeLineJoinMap[strokeLineJoinRaw] || box.strokeLineJoin;
    var strokeWidth = typeof strokeWidthRaw !== 'undefined'
        ? parseFloat(strokeWidthRaw)
        : box.strokeWidth;
    var fontFamily = fontFamilyRaw || box.fontFamily;
    var fontSize = typeof fontSizeRaw !== 'undefined' ? parseFloat(fontSizeRaw) : box.fontSize;
    if (attributes.transform) {
        var regexTransform = /(\w+)\((.+?)\)/g;
        var parsed = regexTransform.exec(attributes.transform);
        while (parsed !== null) {
            var name_1 = parsed[1], rawArgs = parsed[2];
            var args = (rawArgs || '')
                .split(/\s*,\s*|\s+/)
                .filter(function (value) { return value.length > 0; })
                .map(function (value) { return parseFloat(value); });
            var result = transform({ x: x, y: y }, name_1, args);
            x = result.x;
            y = result.y;
            parsed = regexTransform.exec(attributes.transform);
        }
    }
    if (box.converter) {
        x = box.converter.x(x);
        y = box.converter.y(y);
        x1 = box.converter.x(x1);
        y1 = box.converter.y(y1);
        x2 = box.converter.x(x2);
        y2 = box.converter.y(y2);
        cx = box.converter.x(cx);
        cy = box.converter.y(cy);
        r = box.converter.x(r);
        rx = box.converter.x(rx);
        ry = box.converter.y(ry);
    }
    if (constraints === null || constraints === void 0 ? void 0 : constraints.width) {
        var constraintsConverterX = function (xReal) {
            return (xReal * (width || 0)) / (constraints.width || 1);
        };
        x = constraintsConverterX(x);
        x1 = constraintsConverterX(x1);
        x2 = constraintsConverterX(x2);
        cx = constraintsConverterX(cx);
        r = constraintsConverterX(r);
        rx = constraintsConverterX(rx);
    }
    if (constraints === null || constraints === void 0 ? void 0 : constraints.height) {
        var constraintsConverterY = function (yReal) {
            return (yReal * (height || 0)) / (constraints.height || 1);
        };
        y = constraintsConverterY(y);
        y1 = constraintsConverterY(y1);
        y2 = constraintsConverterY(y2);
        cy = constraintsConverterY(cy);
        ry = constraintsConverterY(ry);
    }
    var viewBox;
    var converter;
    if (['g', 'svg'].includes(element.tagName)) {
        viewBox = (attributes.viewBox || '')
            .split(/\s*,\s*|\s+/)
            .filter(function (value) { return value.length > 0; })
            .map(function (value) { return parseFloat(value); })
            .reduce(function (pos, value, i) {
            if (i === 0)
                pos.xMin = value;
            if (i === 1)
                pos.yMin = value;
            if (i === 2)
                pos.width = value;
            if (i === 3)
                pos.height = value;
            return pos;
        }, {
            xMin: 0,
            yMin: 0,
            width: width || 0,
            height: height || 0,
        });
        if (!width) {
            width = viewBox.width;
        }
        if (!height) {
            height = viewBox.height;
        }
        var boxXmin_1 = viewBox.xMin;
        var boxYmin_1 = viewBox.yMin;
        var boxWidth_1 = viewBox.width;
        var boxHeight_1 = viewBox.height;
        converter = {
            x: function (xReal) {
                return x + ((xReal - boxXmin_1) * (width || 0)) / (boxWidth_1 - boxXmin_1);
            },
            y: function (yReal) {
                return y + ((yReal - boxYmin_1) * (height || 0)) / (boxHeight_1 - boxYmin_1);
            },
        };
    }
    if (element.tagName === 'text' && fontSize) {
        y += fontSize;
    }
    return {
        width: width || 0,
        height: width || 0,
        x: x,
        y: y,
        fill: fill,
        fillOpacity: fillOpacity,
        stroke: stroke,
        strokeWidth: strokeWidth,
        strokeOpacity: strokeOpacity,
        strokeLineCap: strokeLineCap,
        strokeLineJoin: strokeLineJoin,
        cx: cx,
        cy: cy,
        r: r,
        rx: rx,
        ry: ry,
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2,
        d: attributes.d,
        src: attributes.src,
        fontFamily: fontFamily,
        fontSize: fontSize,
        viewBox: viewBox,
        converter: converter,
    };
};
var parseSvgElement = function (element, parentElement, constraints) {
    var htmlElement = typeof element === 'string'
        ? parseHtml(element).firstChild
        : element;
    return Object.assign({}, htmlElement, {
        svgAttributes: parseAttributes(htmlElement, parentElement, constraints),
    });
};
var parse = function (svg, constraints) {
    var ret = [];
    var parentElement = typeof svg === 'string'
        ? parseSvgElement(svg, undefined, constraints)
        : svg;
    for (var _i = 0, _a = parentElement.childNodes; _i < _a.length; _i++) {
        var childNode = _a[_i];
        if (childNode.nodeType !== 1)
            continue;
        var element = parseSvgElement(childNode, parentElement);
        if (['g', 'svg'].includes(element.tagName)) {
            ret.push.apply(ret, parse(element));
        }
        else {
            ret.push(element);
        }
    }
    return ret;
};
export var drawSvg = function (page, svg, options) { return __awaiter(void 0, void 0, void 0, function () {
    var elements, runners, i, c;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                elements = parse(svg, options);
                runners = runnersToPage(page, options);
                i = 0;
                _a.label = 1;
            case 1:
                if (!(i < elements.length)) return [3 /*break*/, 4];
                c = elements[i];
                if (!(typeof runners[c.tagName] === 'function')) return [3 /*break*/, 3];
                return [4 /*yield*/, runners[c.tagName](c)];
            case 2:
                _a.sent();
                _a.label = 3;
            case 3:
                i++;
                return [3 /*break*/, 1];
            case 4: return [2 /*return*/];
        }
    });
}); };
//# sourceMappingURL=svg.js.map